import { path } from 'ramda';
import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import {
  fetchAddTemporarily,
  IAddTemporarilyResponse200 as IRes200,
} from '../../repositories/encrypted-file-manager/v2/add-temporarily';
import { TThunkAction } from '../../types/redux';
import { EFileUploadErrorMessages } from './constants';
import { mapEncryptedFileToAttachedDocument } from './utils/mapEncryptedFileToAttachedDocument';
import { IAttachedDocument } from '../../types/requestFormValue';

const DEFAULT_UPLOAD_TIMEOUT = 60000;

export interface IUploadDocumentProps {
  file: File;
}
export const uploadFile =
  (props: IUploadDocumentProps): TThunkAction<Promise<IAttachedDocument>> =>
  async (dispatch, getState, context) => {
    const { httpApi, logger, config } = context;

    const uploadFilesTimeout =
      config.get<number>('legal-check-request-form-frontend.uploadFiles.timeout') || DEFAULT_UPLOAD_TIMEOUT;

    try {
      const result = await fetchAddTemporarily<IRes200>({
        httpApi,
        parameters: { file: props.file },
        config: {
          ecnhancersConfig: {
            timeout: uploadFilesTimeout,
          },
        },
      });

      if (result.statusCode === 200) {
        return mapEncryptedFileToAttachedDocument(result.response);
      }

      throw new HttpBadStatusCodeError(
        `${EFileUploadErrorMessages.InvalidResponse}: ${(result.response as unknown as { message: string }).message}`,
        result.statusCode,
      );
    } catch (e) {
      const logPayload = {
        domain: 'actions/file#uploadFile',
        meta: {
          fileSize: path<number>(['size'], props.file),
          fileType: path<string>(['type'], props.file),
        },
      };

      if (e instanceof HttpBadStatusCodeError) {
        logger.warning(e, logPayload);

        throw e;
      }

      logger.error(e, logPayload);

      throw new Error(`Не удалось загрузить файл ${props.file.name}. Попробуйте еще раз.`);
    }
  };
